// /opt/isp_erp/frontend/src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useJsApiLoader } from "@react-google-maps/api";

import Login from "./auth/Login";
import RequireAuth from "./auth/RequireAuth";
import MainLayout from "./layout/MainLayout";

// Páginas
import Dashboard from "./pages/Dashboard";

// ADMINISTRATIVO
import Clientes from "./pages/admin/clientes/Clientes";
import CreateCustomer from "./pages/admin/clientes/CreateCustomer";
import EditCustomer from "./pages/admin/clientes/EditCustomer";
import MapaClientes from "./pages/admin/clientes/MapaClientes";

import Installations from "./pages/admin/instalaciones/Installations";
import DarDeAlta from "./pages/admin/instalaciones/DarDeAlta";

import Contratos from "./pages/admin/contratos/Contratos";
import Servicios from "./pages/admin/servicios/Servicios";
import UsuariosClientes from "./pages/admin/clientes/UsuariosClientes";
import ClienteDetalle from "./pages/admin/clientes/ClienteDetalle";
import ClientesPorEstado from "./pages/admin/clientes/ClientesPorEstado";
import FacturasList from './pages/admin/finanzas/FacturasList';
import FacturaDetalle from './pages/admin/finanzas/FacturaDetalle';
import FacturaForm from './pages/admin/finanzas/FacturaForm';
import PagosList from './pages/admin/finanzas/PagosList';
import ReportesFinanzas from './pages/admin/finanzas/ReportesFinanzas';
import PromesasList from './pages/admin/finanzas/promesas/PromesasList';
import PromesaForm from './pages/admin/finanzas/promesas/PromesaForm';
import PromesaDetalle from './pages/admin/finanzas/promesas/PromesaDetalle';
import CargaMasiva from "./pages/admin/instalaciones/CargaMasiva";
import Sucursales from "./pages/admin/finanzas/sucursales/Sucursales";
import ReportesFinancieros from "./pages/admin/finanzas/ReportesFinancieros";
import DashboardFinanciero from "./pages/admin/finanzas/DashboardFinanciero";
import CuentasBancarias from "./pages/admin/finanzas/CuentasBancarias";
import PuntosCobro from "./pages/admin/finanzas/PuntosCobro";

// USUARIOS Y ROLES
import Usuarios from "./pages/Usuarios";
import Roles from "./pages/Roles";

// TÉCNICO
import OLTs from "./pages/OLTs";
import OLTStatus from "./pages/OLTStatus";
import OLTOnus from "./pages/OLTOnus";
import ONUDetail from "./pages/ONUDetail";
import ONUAdministracion from './pages/ONUAdministracion';
import ONUManagement from './pages/ONUManagement';

// VARIOS
import Pagos from "./pages/Pagos";
import Estadisticas from "./pages/Estadisticas";

// MIKROTIK
import MikroTiks from './pages/MikroTiks';
import MikroTikPools from './pages/MikroTikPools';
import MikroTikAddressLists from './pages/MikroTikAddressLists';
import MikroTikClientIP from './pages/MikroTikClientIP';
import MikroTiksGestion from "./pages/mikrotik/MikroTiksGestion";
// TICKETS
import Tickets from './pages/Tickets';
import TicketsStats from './pages/TicketsStats';
import SlaConfig from './pages/admin/SlaConfig';
import CalendarView from './pages/tickets/CalendarView';
// ✅ CALL CENTER
import CallCenter from './pages/CallCenter';

// Importaciones nuevas
import WarehouseDashboard from './pages/warehouse/Dashboard';
import WarehouseInventory from './pages/warehouse/Inventory';
import WarehouseEquipos from './pages/warehouse/Equipos';
import WarehouseMovimientos from './pages/warehouse/Movimientos';
import WarehousePendientes from './pages/warehouse/Pendientes';
import WarehouseRMA from './pages/warehouse/RMA';
import WarehouseNuevoEquipo from './pages/warehouse/NuevoEquipo';
import DespacharEquipo from './pages/warehouse/DespacharEquipo';
import CreateInstalacionTicket from './pages/tickets/CreateInstalacionTicket';
import CreateRetiroTicket from './pages/tickets/CreateRetiroTicket';
import CreateCambioEquipoTicket from './pages/tickets/CreateCambioEquipoTicket';
import Materiales from './pages/warehouse/Materiales';

// NAPS
import NapsMap from './pages/ftth/NapsMap';
import NapsList from './pages/ftth/NapsList';
import NapForm from './pages/ftth/NapForm';
import Reports from './pages/ftth/Reports';
import Topology from './pages/ftth/Topology';

// DISCO
import DiskManager from './pages/admin/DiskManager';

// BACKUP
import BackupManager from './pages/admin/BackupManager';

const libraries = ["places"];

export default function App() {

  // 🔥 Google Maps se carga UNA sola vez aquí
  const { isLoaded } = useJsApiLoader({
    id: "google-map-global",
    googleMapsApiKey: "AIzaSyALB9z0GfpEGVycrKANs9QOmyaj2_bEjBw",
    libraries,
  });

  if (!isLoaded) return <div>Cargando sistema...</div>;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<RequireAuth />}>
          <Route element={<MainLayout />}>

            <Route path="/dashboard" element={<Dashboard />} />

            {/* ADMINISTRATIVO */}
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/clientes/nuevo" element={<CreateCustomer />} />
            <Route path="/clientes/editar/:customerId" element={<EditCustomer />} />
            <Route path="/clientes/mapa" element={<MapaClientes />} />

            {/* 👇 RUTA PARA USUARIOS CLIENTES */}
            <Route path="/clientes/usuarios" element={<UsuariosClientes />} />

            {/* 👇 NUEVA RUTA PARA DETALLE DE CLIENTE */}
            <Route path="/clientes/detalle/:customerId" element={<ClienteDetalle />} />

            {/* 👇 NUEVA RUTA PARA INSTALACIONES */}
            <Route path="/clientes/instalaciones" element={<Installations />} />
            <Route path="/clientes/instalaciones/dar-de-alta/:id" element={<DarDeAlta />} />
            <Route path="/instalaciones/carga-masiva" element={<CargaMasiva />} />

            {/* 👇 NUEVA RUTA PARA FACTURACION */}
            <Route path="/finanzas/facturas" element={<FacturasList />} />
            <Route path="/finanzas/facturas/:id" element={<FacturaDetalle />} />
            <Route path="/finanzas/facturas/nueva" element={<FacturaForm />} />
            <Route path="/finanzas/pagos" element={<PagosList />} />
            <Route path="/finanzas/reportes" element={<ReportesFinanzas />} />
            <Route path="/finanzas/sucursales" element={<Sucursales />} />
            <Route path="/finanzas/reportes-financieros" element={<ReportesFinancieros />} />
            <Route path="/finanzas/dashboard" element={<DashboardFinanciero />} />
            <Route path="/finanzas/cuentas-bancarias" element={<CuentasBancarias />} />
            <Route path="/finanzas/puntos-cobro" element={<PuntosCobro />} />

            {/* 👇 NUEVA RUTA PARA PROMESA DE PAGO */}
            <Route path="/finanzas/promesas" element={<PromesasList />} />
            <Route path="/finanzas/promesas/nueva" element={<PromesaForm />} />
            <Route path="/finanzas/promesas/:id" element={<PromesaDetalle />} />

            <Route path="/clientes/contratos" element={<Contratos />} />
            <Route path="/servicios" element={<Servicios />} />

            <Route path="/clientes/:estado" element={<ClientesPorEstado />} />

            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/clientes/usuarios" element={<UsuariosClientes />} />

            <Route path="/olts" element={<OLTs />} />
            <Route path="/olt-status" element={<OLTStatus />} />
            <Route path="/olts/:oltId/onus" element={<OLTOnus />} />
            <Route path="/olts/:oltId/onus/:onuIndex" element={<ONUDetail />} />
            <Route path="/olt/:oltId/management" element={<ONUManagement />} />
            <Route path="/onu-administracion" element={<ONUAdministracion />} />

            <Route path="/estadisticas" element={<Estadisticas />} />

            {/* MIKROTIK */}
            <Route path="/mikrotiks" element={<MikroTiks />} />
            <Route path="/mikrotik/pools" element={<MikroTikPools />} />
            <Route path="/mikrotik/address-lists" element={<MikroTikAddressLists />} />
            <Route path="/mikrotik/client-ip" element={<MikroTikClientIP />} />
            <Route path="/mikrotiks/gestion" element={<MikroTiksGestion />} />
            {/* TICKETS */}
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/tickets/stats" element={<TicketsStats />} />
            <Route path="/sla-config" element={<SlaConfig />} />
            <Route path="/tickets/calendario" element={<CalendarView />} />
            {/* ✅ CALL CENTER */}
            <Route path="/call-center" element={<CallCenter />} />
            {/* BODEGA */}
            <Route path="/warehouse" element={<WarehouseDashboard />} />
            <Route path="/warehouse/inventory" element={<WarehouseInventory />} />
            <Route path="/warehouse/equipos" element={<WarehouseEquipos />} />
            <Route path="/warehouse/movimientos" element={<WarehouseMovimientos />} />
            <Route path="/warehouse/pendientes" element={<WarehousePendientes />} />
            <Route path="/warehouse/rma" element={<WarehouseRMA />} />
            <Route path="/warehouse/nuevo" element={<WarehouseNuevoEquipo />} />
            <Route path="/warehouse/despachar/:sn" element={<DespacharEquipo />} />
            <Route path="/warehouse/materiales" element={<Materiales />} />
            <Route path="/tickets/instalacion" element={<CreateInstalacionTicket />} />
            <Route path="/tickets/retiro" element={<CreateRetiroTicket />} />
            <Route path="/tickets/cambio-equipo" element={<CreateCambioEquipoTicket />} />

            {/* FTTH */}
            <Route path="/ftth/naps" element={<NapsMap />} />
            <Route path="/ftth/naps/lista" element={<NapsList />} />
            <Route path="/ftth/naps/nuevo" element={<NapForm />} />
            <Route path="/ftth/reportes" element={<Reports />} />
            <Route path="/ftth/red" element={<Topology />} />

            {/* DISCO */}
            <Route path="/disk" element={<DiskManager />} />

            {/* BACKUP */}
            <Route path="/backup" element={<BackupManager />} />

          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
